import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class XWareLogService {
  arrLogType = [];

  constructor() {
    const logType = localStorage.getItem('xwdebug-type');
    if (logType) {
      this.arrLogType = logType.split(',');
    }
  }

  log(msg: string = '', sType: string = '') {
    if (this.okToLog(sType)) {
      const d = new Date();
      const options = { timeZone: 'UTC' };
      let typeAbbrev = '';
      if (sType) {
        typeAbbrev = ' [' + sType + '] ';
      }
    }
  }

  okToLog(sType): boolean {
    let bLog = false; // don't log to production unless xwdebug is set
    if (isDevMode() || localStorage.getItem('xwdebug') === 'true') {
      // If a type has been set, restrict the logs to those types
      bLog = true;
      if (sType && this.arrLogType.length > 0) {
        if (this.arrLogType.findIndex(x => x === sType) < 0) {
          bLog = false;
        }
      }
    }

    return bLog;
  }
}
